import apiClient from "../../utils/interceptor"
import { ApiResponse, CompanyData, CreateCompanyParams, CreateCompanyResponse, UpdateCompanyParams } from "./interface";
import { API_URLS } from "../../constants";

// Helper function to get auth token from localStorage
const getAuthToken = (): string | null => {
    return localStorage.getItem("auth_token");
};

// Function to get all companies
export const getAllCompanies = async (): Promise<ApiResponse<CompanyData[]>> => {
    const token = getAuthToken();

    try {
        const response = await apiClient.get<ApiResponse<CompanyData[]>>(
            API_URLS.COMPANY.GET_COMPANIES,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching companies:", error);
        throw error;
    }
};

// Function to create a company
export const createCompany = async (
    companyParams: CreateCompanyParams
): Promise<ApiResponse<CreateCompanyResponse>> => {
    const token = getAuthToken();

    try {
        const response = await apiClient.post<ApiResponse<CreateCompanyResponse>>(
            API_URLS.COMPANY.CREATE_COMPANY,
            companyParams,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error creating company:", error);
        throw error;
    }
};

// Function to update a company
export const updateCompany = async (
    companyData: UpdateCompanyParams
): Promise<ApiResponse<null>> => {
    const token = getAuthToken();

    try {
        const response = await apiClient.patch<ApiResponse<null>>(
            API_URLS.COMPANY.UPDATE_COMPANY,
            companyData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error updating company:", error);
        throw error;
    }
};

// Function to delete a company
export const deleteCompany = async (
    companyId: string
): Promise<ApiResponse<null>> => {
    const token = getAuthToken();

    try {
        const response = await apiClient.delete<ApiResponse<null>>(
            `${API_URLS.COMPANY.DELETE_COMPANY}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                data: { company_id: companyId }
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error deleting company:", error);
        throw error;
    }
};
